import { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import style from './HallPlans.module.scss'

import floor_1_1 from 'assets/images/floors/floor-1.1.jpg'
import floor_3_1 from 'assets/images/floors/floor-3.1.jpg'
// import floor_3_2 from 'assets/images/floors/floor-3.2.png'
// import floor_5_1 from 'assets/images/floors/floor-5.1.png'
// import floor_5_2 from 'assets/images/floors/floor-5.2.png'

const floors = {
    0: [floor_1_1, floor_3_1],
    1: [floor_1_1],
    3: [floor_3_1],
    5: []
}

function Fancybox(props) {
    const containerRef = useRef(null);
  
    useEffect(() => {
      const container = containerRef.current;
  
      const delegate = props.delegate || "[data-fancybox]";
      const options = props.options || {};
  
      NativeFancybox.bind(container, delegate, options);
  
      return () => {
        NativeFancybox.unbind(container);
        NativeFancybox.close();
      };
    });
  
    return <div ref={containerRef}>{props.children}</div>;
}

const Tabs = ({ onChange, floor })=> {
    const click = id => ()=> onChange(id)
    const { t } = useTranslation()
    const [all, n1, n3] = t('hall.floor', { returnObjects: true })
    return (
        <div className={style.tabs}>
            <button onClick={click(0)} className={floor === 0 ? style.is_active : ''}>{all}</button>
            <button onClick={click(1)} className={floor === 1 ? style.is_active : ''}>{n1}</button>
            <button onClick={click(3)} className={floor === 3 ? style.is_active : ''}>{n3}</button>
            {/* <button onClick={click(5)} className={floor === 5 ? style.is_active : ''}>{n5}</button> */}
        </div>
    )
}

export const HallPlans =()=> {
    const { t } = useTranslation()
    const [floor, setFloor] = useState(0)

    const onChange = floor=> {
        if (floors[floor].length === 0) return
        setFloor(floor)
    }

    const data = floors[floor]

    return (
        <div className={style.block} id="plans">
            <div className="container">
                <div className={style.box}>
                    <div className={style.title}>
                        {t('hall.title')}
                    </div>
                    <Tabs onChange={onChange} floor={floor} />

                    <div className={style.schemas}>
                        <Fancybox >
                            <div className={style.side_img}>
                                {data.map(item => (
                                    <a data-fancybox="gallery" href={item}  key={item} className={style.sm_img}>
                                        <picture>
                                            <img src={item} alt="" />
                                        </picture>
                                    </a>
                                ))}
                            </div>
                        </Fancybox>
                    </div>
                </div>
            </div>
        </div>
    )
}